function initComponents() {
  // See if the timezone can be passed, allowing clients to have session time information in their zone.
  document.querySelector("input[name$=-timezone]").value = Intl.DateTimeFormat().resolvedOptions().timeZone;

  document
    .querySelectorAll(".intake-form .collapse")
    .forEach((e) => e.addEventListener("shown.bs.collapse", (event) => event.target.parentElement.scrollIntoView()));
}

// bulk initialize all components
document.body ? initComponents() : addEventListener("DOMContentLoaded", initComponents, { once: true });
